export class AuthApiRouter {
  apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  me(): string {
    return `${this.apiUrl}/auth/me`;
  }

  signOut(): string {
    return `${this.apiUrl}/auth/sign-out`;
  }

  login(): string {
    return `${this.apiUrl}/auth/login`;
  }
}

export class ApiRouter {
  apiUrl: string;
  auth: AuthApiRouter;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
    this.auth = new AuthApiRouter(apiUrl);
  }

  url(url: string): string {
    return `${this.apiUrl}/${url}`;
  }
}
